import { createFieldBase, FieldBase, FieldBaseArguments } from './FieldBase';

export function createMailButtonField({
  value,
  ...options
}: MailButtonFieldArguments): MailButtonField {
  const fieldBase = createFieldBase(options);

  let self: MailButtonField = {
    ...fieldBase,
    value,
    componentType: 'mail-button',
  };

  return self;
}

// TYPES:
export interface MailButtonFieldArguments extends FieldBaseArguments {
  value?: string | number | boolean;
}

export interface MailButtonField extends FieldBase {
  componentType: string;
  value?: string | number | boolean;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/models/Field/MailButtonField.ts